export const MODULE_NAME = 'crm';
export const ACCESS_NAME = 'CRM';
